import { render, staticRenderFns } from "./ServiceOrderDVIRsComponent.vue?vue&type=template&id=233d0498&"
import script from "./ServiceOrderDVIRsComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderDVIRsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports